import { toast } from 'react-toastify';

export function checkError(err) {
    const status = err?.response?.status;
    const message =
        err?.response?.data?.message ||
        err?.message ||
        'Something went wrong. Please try again.';

    if (status === 401) {
        localStorage.removeItem('customerToken');
        localStorage.removeItem('customerRefreshToken');
        localStorage.removeItem('loggedCustomer');
    } else if (status === 500) {
        // window.location.href = process.env.REACT_APP_WEB_URL + "/#/error-500";
    }

    toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored"
    });
}

export const apiTimeout = (promise) => {
    return new Promise((resolve, reject) => {
      const timeoutId = setTimeout(() => {
        reject(new Error('Request timed out'));
      }, 30000);

      promise
        .then((response) => {
          clearTimeout(timeoutId);
          resolve(response);
        })
        .catch((error) => {
          clearTimeout(timeoutId);
          reject(error);
        });
    });
  };